import { useMemo } from "react";
import { Stack } from "@mui/material";

//import WGRShopGroup from "./ucGroup";
import WGRTable from "./ueTable";

export default function WGRViewer({ rows }) {
 
    
  return (
    <Stack >
{/* THIS IS WHERE WGRTable SHOULD BE */}
   <WGRTable
  rows={rows}
 
  showTotal={true}
/>


     

  


    </Stack>
  );
}